import styled from 'styled-components';
import DisplayText from '@sdk/components/ui/DisplayText';
import EllipsisStyle from '@sdk/components/ui/EllipsisStyle';

import { EVENT_TEXT_LINE_HEIGHT } from '../windowed/constants';

type Props = {
  color?: string;
  hoverColor?: string;
  // @TODO figure out how to style props without AnyStyledComponent
  hoverComponent?: any;
  bold?: boolean;
};
export default styled(DisplayText)<Props>`
  ${EllipsisStyle}
  font-size: 11px;
  line-height: ${EVENT_TEXT_LINE_HEIGHT}px;
  color: ${({ color, theme }): string => (color ? color : theme.colors.white)};

  ${({ hoverComponent, color, hoverColor, theme }): string => {
    if (!hoverComponent) {
      return '';
    }

    return `
     ${hoverComponent}:hover & {
      color: ${hoverColor || (color ? color : theme.colors.white)};
    }
    `;
  }}
`;
